import React from 'react'
import { BaseForm, Select, VALIDATION_TYPES, Checkbox } from 'components/Form'
import {
  ANALYTIC_SCHEMA,
  ANALYTIC_PLACEHOLDER,
  formatFormData,
  getConfig,
  isDsConfigurable,
  isCardSwimlane,
  DRESSUP_CONFIG,
  isTrackable,
} from './utils'
import Loader from 'components/Loader'
import Recommender from './Recommender'
import { getMessage } from 'lib/translator'
import ModuleActions from './ModuleActions'
import ModuleMetadata from './ModuleMetadata'
import SwimlaneDressup from './SwimlaneDressup/SwimlaneDressup'
import FlashDealSwimlane from './SwimlaneDressup/FlashDealSwimlane'
import { validateAnalytics, formatDateTime } from '../utils'
import { APP_PAGES } from 'components/Engage/utils'
import Analytic from '../Analytic'
import _unset from 'lodash/unset'
import _set from 'lodash/set'
import _get from 'lodash/get'
import API from 'lib/api'
import './style.css'

class ModuleForm extends BaseForm {
  constructor(props) {
    super(props)

    this.state = {
      submitAsDraft: false,
      errorFields: {},
      datasource: [],
      isLoading: false,
      enableSwimlaneDressup: false,
      enableTimerConfiguration: false,
      values: {
        mConfig: {
          default: {},
        },
      },
    }

    this.addUrlParams = this.addUrlParams.bind(this)
    this.deleteUrlParams = this.deleteUrlParams.bind(this)
    this.handleDatasource = this.handleDatasource.bind(this)
    this.formatDatasource = this.formatDatasource.bind(this)
    this.unsetObjState = this.unsetObjState.bind(this)
    this.setObjState = this.setObjState.bind(this)
    this.handleSwimlaneDressup = this.handleSwimlaneDressup.bind(this)
    this.handleTimerConfiguration = this.handleTimerConfiguration.bind(this)
  }

  async componentDidMount() {
    // Scroll to top when component mounts
    window.scrollTo(0, 0)

    this.setState({ isLoading: true })
    const { router, moduleType } = this.props
    const { action } = router.match.params

    const fetchDataSourceAPI = new API({
      url: `/genie/lms/datasource?mType=${moduleType}`,
    })

    if (action === 'edit') {
      fetchDataSourceAPI.get().then((res) => {
        const values = formatFormData(this.props.moduleValues)
        const datasource = this.formatDatasource(moduleType, res)
        this.setState({
          values,
          datasource,
          isLoading: false,
          enableSwimlaneDressup: !!values.mConfig.default?.style,
          enableTimerConfiguration:
            !!values.mConfig.default.style?.countdownTimer?.startTime,
        })
      })
    }
    if (action === 'add') {
      fetchDataSourceAPI.get().then((res) => {
        const datasource = this.formatDatasource(moduleType, res)
        this.setState({ datasource, isLoading: false })
      })
    }
  }

  onSubmit(_data) {
    const hasAnalytics = _data.mConfig.default.analytic?.content
    if (hasAnalytics) {
      const { isValid, parsedAnalytic, errors } = validateAnalytics(
        _data.mConfig.default.analytic.content,
        ANALYTIC_SCHEMA
      )
      if (isValid) {
        _set(_data, 'mConfig.default.analytic.content', parsedAnalytic)
      } else {
        this.setState({
          errorFields: { swimlane: errors[0].stack },
        })
        return
      }
    } else {
      _unset(_data, 'mConfig.default.analytic')
    }

    this.setState({ isLoading: true })
    let payload
    let apiUrl
    let method
    const { action } = this.props.router.match.params
    const { mName, mDataSource } = _data
    const sharedPayload = {
      mConfig: getConfig(_data),
      mIsEnable: !this.state.submitAsDraft,
      mType: this.props.moduleType,
    }

    if (this.props.enableSegmentConfig) {
      sharedPayload.segment = _data.segment ? _data.segment.name : null
    }

    if (!this.state.enableSwimlaneDressup) {
      _unset(sharedPayload, 'mConfig.default.style')
    }

    if (!this.state.enableTimerConfiguration) {
      _unset(sharedPayload, 'mConfig.default.style.countdownTimer')
    } else {
      const { startTime, startDate } =
        _data.mConfig.default.style.countdownTimer
      _set(
        sharedPayload,
        'mConfig.default.style.countdownTimer.startTime',
        formatDateTime(startDate, startTime)
      )
    }

    if (action === 'edit') {
      payload = {
        mName,
        mDataSource,
        ...sharedPayload,
      }
      apiUrl = `/genie/lms/module/config?module_pk=${_data.id}`
      method = 'patch'
    }

    if (action === 'add') {
      payload = {
        ..._data,
        omniProfile: this.props.layout,
        mType: this.props.moduleType,
        ...sharedPayload,
      }
      apiUrl = '/genie/lms/module'
      method = 'post'
    }

    if (this.props.page === APP_PAGES[0]) {
      const { id } = this.props.router.match.params
      new API({ url: apiUrl })[method](payload).then(() => {
        this.props.setLayout({ name: id.split('_')[0] })
        this.props.router.history.push(
          this.props.router.location.pathname.replace(
            /(\/add\/.*)|(\/edit\/.*)$/,
            ''
          )
        )
      })
    }

    if (this.props.page === APP_PAGES[1]) {
      this.setState({ isLoading: false })
      this.props.onSubmitX4ULayoutForm(
        null,
        this.state.submitAsDraft,
        'update-module',
        {
          ...payload,
          mIsEnable: _data.mIsEnable,
        }
      )
    }
  }

  addUrlParams() {
    const values = Object.assign({}, this.state.values)
    const index = Object.values(
      values.mConfig.default.apiConfig.urlParams
    ).length
    values.mConfig.default.apiConfig.urlParams[index] = {
      id: crypto.randomUUID(),
    }
    this.setState({ values })
  }

  deleteUrlParams(id, index) {
    const values = Object.assign({}, this.state.values)
    const validations = Object.assign({}, this.state.validations)
    values.mConfig.default.apiConfig.urlParams = Object.values(
      values.mConfig.default.apiConfig.urlParams
    )
      .filter((param) => param.id !== id)
      .reduce((accumulator, item, idx) => {
        accumulator[idx] = item
        return accumulator
      }, {})
    validations.mConfig.default.apiConfig.urlParams =
      validations.mConfig.default.apiConfig.urlParams.filter(
        (_, idx) => idx !== index
      )

    this.setState({ values, validations })
  }

  handleDatasource(datasource, type) {
    const newValues = Object.assign({}, this.state.values)
    const validations = Object.assign({}, this.state.validations)
    const hasUrlParams = newValues.mConfig.default.apiConfig?.urlParams
    const hasAnalytics = newValues.mConfig.default.analytic?.content
    if (isDsConfigurable(datasource) && !hasUrlParams) {
      this.setState({
        values: {
          ...newValues,
          mConfig: {
            default: {
              ...newValues.mConfig.default,
              apiConfig: {
                urlParams: {
                  0: { id: crypto.randomUUID() },
                },
              },
            },
          },
        },
      })
    }

    if (!isDsConfigurable(datasource) && hasUrlParams) {
      delete newValues.mConfig.default.apiConfig
      delete validations.mConfig.default.apiConfig
      this.setState({ values: newValues, validations })
    }

    if (
      type === 'product-swimlane' &&
      !isDsConfigurable(datasource) &&
      hasAnalytics
    ) {
      delete newValues.mConfig.default.analytic
      this.setState({ values: newValues, validations })
    }
  }

  formatDatasource(type, res) {
    return res.map((item) => ({
      text: isCardSwimlane(type)
        ? item.api
        : getMessage(`app.layout.module.datasource.${item.api}`),
      value: item.api,
    }))
  }

  handleTimerConfiguration(isEnabled) {
    this.setState({ enableTimerConfiguration: isEnabled })
    if (isEnabled) {
      const hasTextColor = _get(
        this.state.values,
        'mConfig.default.style.countdownTimer.textColor'
      )
      const hasBgColor = _get(
        this.state.values,
        'mConfig.default.style.countdownTimer.bgColor'
      )
      if (!hasTextColor) {
        this.setObjState(
          'values',
          'mConfig.default.style.countdownTimer.textColor',
          DRESSUP_CONFIG['timer-text-colour']
        )
      }

      if (!hasBgColor) {
        this.setObjState(
          'values',
          'mConfig.default.style.countdownTimer.bgColor',
          DRESSUP_CONFIG['timer-background-colour']
        )
      }
    } else {
      this.unsetObjState('validations', 'mConfig.default.style.countdownTimer')
    }
  }

  handleSwimlaneDressup(isEnabled) {
    this.setState({ enableSwimlaneDressup: isEnabled })
    if (isEnabled) {
      const hasCtaTextColor = _get(
        this.state.values,
        'mConfig.default.style.header.ctaTextColor'
      )
      const hasBgColor = _get(
        this.state.values,
        'mConfig.default.style.background.color'
      )
      if (!hasCtaTextColor) {
        this.setObjState(
          'values',
          'mConfig.default.style.header.ctaTextColor',
          DRESSUP_CONFIG['swimlane-cta-text-colour']
        )
      }
      if (!hasBgColor) {
        this.setObjState(
          'values',
          'mConfig.default.style.background.color',
          DRESSUP_CONFIG['swimlane-background-colour']
        )
      }
    } else {
      this.unsetObjState('validations', 'mConfig.default.style')
    }
  }

  setObjState(key, path, value) {
    const newState = Object.assign({}, this.state[key])
    _set(newState, path, value)
    this.setState({ [key]: newState })
  }

  unsetObjState(key, path) {
    const newState = Object.assign({}, this.state[key])
    _unset(newState, path)
    this.setState({ [key]: newState })
  }

  render() {
    const {
      isLoading,
      errorFields,
      datasource,
      values,
      enableSwimlaneDressup,
      enableTimerConfiguration,
    } = this.state
    const { Form } = this.components
    const {
      router,
      enableSegmentConfig,
      moduleType: mType,
      layout,
      page,
      onCancel,
    } = this.props
    const { action } = router.match.params

    return (
      <>
        {page === APP_PAGES[0] && (
          <h1>{getMessage(`app.layout.module.${action}`)}</h1>
        )}
        {isLoading && <Loader />}
        {!isLoading && (
          <Form className="module-form-section">
            {page === APP_PAGES[1] && (
              <ModuleActions
                page={page}
                action={action}
                mIsNew={action === 'add' || values.mIsNew}
                mIsEnable={values.mIsEnable}
                generateStateMappers={this.generateStateMappers}
                onDeleteModule={this.props.onDeleteModule}
              />
            )}
            <ModuleMetadata
              generateStateMappers={this.generateStateMappers}
              enableSegmentConfig={enableSegmentConfig}
              values={values}
              layout={layout}
              moduleType={mType}
            />
            {mType !== 'placeholder' && (
              <div className="datasource-section">
                <h3>{getMessage('apphome.configurations')}</h3>
                <Select
                  name="Datasource"
                  label={getMessage('app.layout.module.datasource')}
                  placeholder={getMessage(
                    'app.layout.module.datasource.placeholder'
                  )}
                  options={datasource}
                  {...this.generateStateMappers({
                    stateKeys: ['mDataSource'],
                    validationType: VALIDATION_TYPES.ONSUBMIT,
                    loseEmphasisOnFill: true,
                    onChange: (value) => {
                      this.handleDatasource(value, mType)
                    },
                  })}
                />
              </div>
            )}
            {isDsConfigurable(values.mDataSource) && (
              // input for multiple key-value pairs
              <Recommender
                addUrlParams={this.addUrlParams}
                deleteUrlParams={this.deleteUrlParams}
                urlParams={_get(
                  values,
                  'mConfig.default.apiConfig.urlParams',
                  {}
                )}
                generateStateMappers={this.generateStateMappers}
              />
            )}
            {isTrackable(mType) && (
              <div className="analytics-section">
                <h3>{getMessage('apphome.analytics')}</h3>
                <Analytic
                  type="swimlane"
                  errorFields={errorFields}
                  dismissErrors={() => this.setState({ errorFields: {} })}
                  placeholder={ANALYTIC_PLACEHOLDER}
                  generateStateMappers={this.generateStateMappers}
                  stateKeys={['mConfig', 'default', 'analytic', 'content']}
                />
              </div>
            )}

            {mType === 'product-swimlane' && (
              <Checkbox
                name="enable-swimlane-dressup"
                inlineLabel={getMessage('app.layout.swimlane-dressup.enable')}
                value={enableSwimlaneDressup}
                onChange={(isEnabled) => {
                  this.handleSwimlaneDressup(isEnabled)
                }}
              />
            )}
            {enableSwimlaneDressup && (
              <SwimlaneDressup
                generateStateMappers={this.generateStateMappers}
                enableTimerConfiguration={enableTimerConfiguration}
                handleTimerConfiguration={(isEnabled) => {
                  this.handleTimerConfiguration(isEnabled)
                }}
              >
                <FlashDealSwimlane
                  headerImg={values.mConfig.default.style.header.imageUrl}
                  ctaTextColor={
                    values.mConfig.default.style.header.ctaTextColor
                  }
                  bgColor={values.mConfig.default.style.background.color}
                  enableTimerConfiguration={enableTimerConfiguration}
                  timerBgColor={
                    values.mConfig.default.style.countdownTimer?.bgColor
                  }
                  timerTextColor={
                    values.mConfig.default.style.countdownTimer?.textColor
                  }
                />
              </SwimlaneDressup>
            )}

            <div className="buttons-section">
              <button className="button" type="button" onClick={onCancel}>
                {getMessage('apphome.cancel')}
              </button>
              {(action === 'add' || page === APP_PAGES[1]) && (
                <button
                  type="button"
                  className="button"
                  data-testid="draft-button"
                  onClick={() => {
                    this.setState({ submitAsDraft: true }, this._submitHandler)
                  }}
                >
                  {getMessage('apphome.saveasdraft')}
                </button>
              )}
              <button
                className="button primary"
                type="button"
                onClick={() => {
                  this.setState({ submitAsDraft: false }, this._submitHandler)
                }}
              >
                {getMessage('apphome.enable')}
              </button>
            </div>
          </Form>
        )}
      </>
    )
  }
}

export default ModuleForm
